export const MENU = [
  {
    name: "home",
    link: "/home",
  },
  {
    name: "shows",
    link: "/shows",
  },
  {
    name: "about us",
    link: "/aboutus",
  },
];

export const COLUMNS_EPISODS = [
  { id: "index", label: "№", minWidth: 10 },
  { id: "name", label: "Episode name", minWidth: 120 },
  { id: "airdate", label: "Airdate", minWidth: 70 },
  { id: "rating", label: "Rating", minWidth: 10 },
];

export const ACTOR_CARDS_PER_PAGE = 4;

export const DEFAULT_IMAGE = "../images/movie-logo.png";

export const GENRES = [
  "Action",
  "Adventure",
  "Anime",
  "Children",
  "Comedy",
  "Crime",
  "DIY",
  "Drama",
  "Espionage",
  "Family",
  "Fantasy",
  "Food",
  "History",
  "Horror",
  "Legal",
  "Medical",
  "Music",
  "Mystery",
  "Nature",
  "Romance",
  "Science-Fiction",
  "Sports",
  "Supernatural",
  "Thriller",
  "Travel",
  "War",
  "Western",
];

export const COUNTRIES = [
  { key: "0", value: "" },
  { key: "1", value: "Afghanistan" },
  { key: "3", value: "Albania" },
  { key: "4", value: "Algeria" },
  { key: "11", value: "Argentina" },
  { key: "12", value: "Armenia" },
  { key: "14", value: "Australia" },
  { key: "15", value: "Austria" },
  { key: "16", value: "Azerbaijan" },
  { key: "19", value: "Bangladesh" },
  { key: "21", value: "Belarus" },
  { key: "22", value: "Belgium" },
  { key: "27", value: "Bolivia, Plurinational State of" },
  { key: "29", value: "Bosnia and Herzegovina" },
  { key: "32", value: "Brazil" },
  { key: "35", value: "Bulgaria" },
  { key: "40", value: "Canada" },
  { key: "45", value: "Chile" },
  { key: "46", value: "China" },
  { key: "49", value: "Colombia" },
  { key: "56", value: "Croatia" },
  { key: "59", value: "Cyprus" },
  { key: "60", value: "Czech Republic" },
  { key: "61", value: "Denmark" },
  { key: "66", value: "Egypt" },
  { key: "70", value: "Estonia" },
  { key: "73", value: "Faroe Islands" },
  { key: "75", value: "Finland" },
  { key: "76", value: "France" },
  { key: "78", value: "French Polynesia" },
  { key: "82", value: "Georgia" },
  { key: "83", value: "Germany" },
  { key: "86", value: "Greece" },
  { key: "100", value: "Hong Kong" },
  { key: "101", value: "Hungary" },
  { key: "102", value: "Iceland" },
  { key: "103", value: "India" },
  { key: "104", value: "Indonesia" },
  { key: "105", value: "Iran, Islamic Republic of" },
  { key: "106", value: "Iraq" },
  { key: "107", value: "Ireland" },
  { key: "109", value: "Israel" },
  { key: "110", value: "Italy" },
  { key: "112", value: "Japan" },
  { key: "115", value: "Kazakhstan" },
  { key: "118", value: "Korea, Democratic People&#039;s Republic of" },
  { key: "119", value: "Korea, Republic of" },
  { key: "123", value: "Latvia" },
  { key: "124", value: "Lebanon" },
  { key: "129", value: "Lithuania" },
  { key: "130", value: "Luxembourg" },
  { key: "135", value: "Malaysia" },
  { key: "136", value: "Maldives" },
  { key: "144", value: "Mexico" },
  { key: "146", value: "Moldova, Republic of" },
  { key: "148", value: "Mongolia" },
  { key: "157", value: "Netherlands" },
  { key: "159", value: "New Zealand" },
  { key: "162", value: "Nigeria" },
  { key: "166", value: "Norway" },
  { key: "169", value: "Pakistan" },
  { key: "174", value: "Peru" },
  { key: "175", value: "Philippines" },
  { key: "177", value: "Poland" },
  { key: "178", value: "Portugal" },
  { key: "179", value: "Puerto Rico" },
  { key: "180", value: "Qatar" },
  { key: "182", value: "Romania" },
  { key: "183", value: "Russian Federation" },
  { key: "195", value: "Saudi Arabia" },
  { key: "197", value: "Serbia" },
  { key: "200", value: "Singapore" },
  { key: "202", value: "Slovakia" },
  { key: "203", value: "Slovenia" },
  { key: "206", value: "South Africa" },
  { key: "208", value: "Spain" },
  { key: "209", value: "Sri Lanka" },
  { key: "214", value: "Sweden" },
  { key: "215", value: "Switzerland" },
  { key: "217", value: "Taiwan, Province of China" },
  { key: "220", value: "Thailand" },
  { key: "225", value: "Trinidad and Tobago" },
  { key: "226", value: "Tunisia" },
  { key: "227", value: "Turkey" },
  { key: "232", value: "Ukraine" },
  { key: "233", value: "United Arab Emirates" },
  { key: "234", value: "United Kingdom" },
  { key: "235", value: "United States" },
  { key: "238", value: "Uzbekistan" },
  { key: "239", value: "Vanuatu" },
  { key: "240", value: "Venezuela, Bolivarian Republic of" },
  { key: "241", value: "Viet Nam" },
];
